// TODO switch to the export object as const + export type approach
export enum TrendingTickerType {
  GAINERS = 'GAINERS',
  LOSERS = 'LOSERS',
  ALL = 'ALL',
}
